import { BREAKPOINTS } from "web/react/constants";
import { useWindowWidth } from "web/react/hooks/use-window-width/use-window-width";

/**
 * Hook that keeps track if the browser is wider than the desktop breakpoint
 */
export function useDesktopBreakpoint(): boolean {
    const windowWidth = useWindowWidth();
    return windowWidth >= BREAKPOINTS.Large;
}

export function useSmallBreakpoint(): boolean {
    const windowWidth = useWindowWidth();
    return windowWidth >= BREAKPOINTS.Small;
}
